<template>
  <div v-loading="loading">
    <div class="tips">
      <i class="el-icon-warning-outline"></i>
      <span>温馨提示：可建立供应商与供应商之间的联系，以便财务对账！</span>
    </div>
    <el-row :gutter="20">
      <el-col :span="24"
        ><div class="grid-content">
          <el-card class="box-card">
            <div class="search-ctn">
              <div class="search-ctn-left">
                <div class="search-name">需要关联的供应商</div>
                <el-select
                  class="search-item"
                  size="small"
                  style="width: 60%"
                  :loading="loading"
                  v-model="supId"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  allow-create
                  :remote-method="searchSupplier"
                  @change="supplierChange($event)"
                  @visible-change="supplierVisibleChange($event)"
                  placeholder="选择需要关联的供应商"
                >
                  <el-option
                    v-for="optionItem in supplierList"
                    :key="optionItem.EntpCusId"
                    :data-msg="optionItem"
                    :label="optionItem.EntpCusName"
                    :value="optionItem.EntpCusId"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="choose-item">
              <el-tag
                v-for="tag in supTags"
                :key="tag.name"
                closable
                type="success"
                class="c-item"
                @close="closeSupTag(tag.id)"
              >
                {{ tag.name }}
              </el-tag>
            </div>
          </el-card>
        </div></el-col
      >
    </el-row>
    <div class="dialog-footer">
      <div class="re-submit">
      <el-button class="btn-primary" @click="submitForm()">提交关联</el-button>
      <el-button type="warning" @click="clear()">清空关联</el-button>
      <el-button @click="cancel()">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["EntpCusId"],
  components: {},
  data() {
    return {
      loading: false,
      cusId: "",
      supId: "",
      sName: "",
      eCusId: this.EntpCusId,
      customerList: [],
      supplierList: [],
      cusTags: [],
      supTags: [],
      // newReleIds: [],
      submitData: {
        OldIds: [],
        NewIds: [],
      },
    };
  },
  mounted() {
    if (this.eCusId) this.getTableData();
  },
  methods: {
    getTableData() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/RevenueManagement/GetEntityReleDatas",
          data: { EntpCusId: this.eCusId },
          hideLoading: true,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.CustomerList.length > 0) {
              var newArr = [];
              res.data.CustomerList.forEach((el) => {
                var isContain = false;
                for (var i = 0; i < this.cusTags.length; i++) {
                  if (el.id == this.cusTags[i].id) {
                    isContain = true;
                    break;
                  } else {
                    isContain = false;
                  }
                }
                if (!isContain) {
                  newArr.push(el);
                }
              });
              this.cusTags = this.cusTags.concat(newArr);
            }
            if (res.data.SupplierList.length > 0) {
              var supTagsArr = [];
              res.data.SupplierList.forEach((el) => {
                var isContain = false;
                for (var i = 0; i < this.supTags.length; i++) {
                  if (el.id == this.supTags[i].id) {
                    isContain = true;
                    break;
                  } else {
                    isContain = false;
                  }
                }
                if (!isContain) {
                  supTagsArr.push(el);
                }
              });
              this.supTags = this.supTags.concat(supTagsArr);
            }
            if (res.data.AllReleIds.length > 0) {
              var OldIdsArr = [];
              res.data.AllReleIds.forEach((el) => {
                var isContain = false;
                for (var i = 0; i < this.submitData.OldIds.length; i++) {
                  if (el.id == this.submitData.OldIds[i]) {
                    isContain = true;
                    break;
                  } else {
                    isContain = false;
                  }
                }
                if (!isContain) {
                  OldIdsArr.push(el);
                }
              });
              this.submitData.OldIds = this.submitData.OldIds.concat(OldIdsArr);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitForm() {
      this.submitData.NewIds = [];
      if (
        this.submitData.OldIds.length == 0 &&
        this.cusTags.length == 0 &&
        this.supTags.length == 0
      ) {
        this.$util.warningMsg("请选择要关联的数据");
        return;
      }

      if (this.cusTags.length + this.supTags.length < 2) {
        this.$util.warningMsg("请选择两个或两个以上的实体进行关联");
        return;
      }

      this.$confirm("您确认要提交实体的数据关联吗？", "提示", {
        confirmButtonText: "确定提交",
        cancelButtonText: "取消",
        type: "warning",
        center: false,
      })
        .then(() => {
          this.loading = true;
          let newReleIds = [];
          if (this.cusTags.length > 0) {
            for (let index = 0; index < this.cusTags.length; index++) {
              newReleIds.push(this.cusTags[index].id);
            }
          }
          if (this.supTags.length > 0) {
            for (let index = 0; index < this.supTags.length; index++) {
              newReleIds.push(this.supTags[index].id);
            }
          }
          if (newReleIds.length < 2) {
            this.$util.warningMsg("请选择两个或两个以上的实体进行关联");
            return;
          }
          this.submitData.NewIds = newReleIds;
          this.$util
            .axiosPost({
              url: "/api/RevenueManagement/SaveEntityReleDatas",
              data: this.submitData,
              hideLoading: true,
            })
            .then((res) => {
              this.$util.successMsg(res.errmsg);
              if (res.errcode === 0) this.clear();
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    cancel() {
      this.$emit("closeDialog");
    },
    // 搜索顾客
    searchCustomer(key) {
      this.loading = true;
      this.customerList = [];
      this.$util
        .searchCustomer(key)
        .then((data) => {
          this.customerList = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //当客户下拉框出现时触发
    customerVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.customerList.length <= 1) that.searchCustomer('');
      }
    },
    customerChange(value) {
      let that = this;
      let currCust = that.customerList.find((e) => e.EntpCusId == value);
      if (currCust) {
        let EntpCusName = currCust.EntpCusName;
        let isHad = false;
        for (var i = 0; i < that.cusTags.length; i++) {
          if (this.cusTags[i].id === value) {
            isHad = true;
          }
        }
        if (!isHad) that.cusTags.push({ name: EntpCusName, id: value });
      }
      that.eCusId = value;
      that.getTableData();
    },
    //搜索供应商
    searchSupplier(key) {
      this.loading = true;
      this.customerList = [];
      this.$util
        .searchSupplier(key)
        .then((data) => {
          this.supplierList = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //当客户下拉框出现时触发
    supplierVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.supplierList.length <= 1) that.searchSupplier();
      }
    },
    supplierChange(value) {
      let that = this;

      let currCust = that.supplierList.find((e) => e.EntpCusId == value);
      if (currCust) {
        let EntpCusName = currCust.EntpCusName;
        let isHad = false;
        for (var i = 0; i < that.supTags.length; i++) {
          if (that.supTags[i].id === value) {
            isHad = true;
          }
        }
        if (!isHad) that.supTags.push({ name: EntpCusName, id: value });
      }

      that.eCusId = value;
      that.getTableData();
    },
    closeCusTag(val) {
      if (val) {
        for (var i = 0; i < this.cusTags.length; i++) {
          if (this.cusTags[i].id === val) {
            this.cusTags.splice(i, 1);
          }
        }
      }
    },
    closeSupTag(val) {
      if (val) {
        for (var i = 0; i < this.supTags.length; i++) {
          if (this.supTags[i].id === val) {
            this.supTags.splice(i, 1);
          }
        }
      }
    },
    clear() {
      this.cusId = "";
      this.supId = "";
      this.sName = "";
      this.customerList = [];
      this.supplierList = [];
      this.submitData = {};
      this.cusTags = [];
      this.supTags = [];
      // this.newReleIds = [];
      this.submitData = {
        OldIds: [],
        NewIds: [],
      };
    },
  },
};
</script>
<style lang="less" scoped>
.choose-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 5px;
  height: 250px;
  overflow-y: scroll;
}
.c-item {
  margin: 5px;
}
.grid-content {
  margin-bottom: 10px;
}
.imgcla {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
}
.link-icon {
  height: 36px;
  width: 50px;
}
.box-card {
  height: 300px;
}
.re-submit {
  text-align: right;
}
.tips {
  color: #F00;
  margin-bottom: 8px;
  i {
    margin-right: 8px;
  }
}
.search-ctn{
  margin-top: 5px;
}
</style>
